<template>
   <div>
      <el-drawer
         title="Filter"
         size="40%"
         :visible.sync="filterDrawerVisibility"
         :direction="filterDrawerDirection"
         :before-close="handleCloseFilterDrawer"
         :with-header="false"
         style="padding-right:0px;">
         <div class="" style="position:sticky;background:white;z-index:10;top:0;">
               <div class="col-md-12">
                  <div class="modal-header">
                     <h5 class="modal-title" style="margin-left:-10px;">Filter Chart Summary</h5>
                     <button type="button" class="close" v-on:click="handleCloseFilterDrawer">
                        <span aria-hidden="true">&times;</span>
                     </button>				
                  </div>
               </div>
         </div>
         <div class="">
            <div class="col-md-12" style="padding:20px;">
               <div class="row mb-3">	
                  <!--			
                  <el-row :gutter="5" style="font-size:14px;color:#303133;">
                     <el-col :span="12">Start Month</el-col>
                     <el-col :span="12">End Month</el-col>
                  </el-row>
                  <el-row :gutter="5">
                     <el-col :span="12">
                        <el-date-picker type="month" placeholder="Pick a month" v-model="form.date1" style="width: 100%;" @change="handleChangeStartMonth"></el-date-picker>
                     </el-col>
                     <el-col :span="12">
                        <el-date-picker type="month" placeholder="Pick a month" v-model="form.date2" style="width: 100%;"></el-date-picker>
                     </el-col>
                  </el-row>
                  -->

                  <div class="col-md-12">
                     <el-checkbox :indeterminate="month.isIndeterminate" v-model="month.checkAll" @change="handleKategoriCheckAllChange(month)" size="medium"><b>Bulan</b></el-checkbox>
                     <el-checkbox-group v-model="month.checked" @change="handleKategoriCheckedChange(month)">
                        <el-checkbox v-for="(item,index) in month.options" :label="item" :key="item.Id+'_'+index">{{item.Name}}</el-checkbox>
                     </el-checkbox-group>
                  </div>
                  
                  <div class="col-md-12 mt-2">
                     <el-checkbox :indeterminate="year.isIndeterminate" v-model="year.checkAll" @change="handleKategoriCheckAllChange(year)" size="medium"><b>Tahun</b></el-checkbox>
                     <el-checkbox-group v-model="year.checked" @change="handleKategoriCheckedChange(year)">
                        <el-checkbox v-for="(item,index) in year.options" :label="item" :key="item.Id+'_'+index">{{item.Name}}</el-checkbox>
                     </el-checkbox-group>
                  </div>									
               </div>

               <div class="row mb-3">
                  <h6>Jenis Data</h6>
                  <div>
                     <el-radio v-model="filter.dataType" label="total">Total</el-radio>
                     <el-radio v-model="filter.dataType" label="detail">Detail</el-radio>
                  </div>
                  
               </div>

               <el-collapse v-model="activeNames" @change="handleChangeCollapse">
                  <el-collapse-item name="1">
                     <template slot="title">
                        <h6 style="margin-top:5px;">Penerimaan</h6>
                     </template>
                     <div>
                        <el-checkbox :indeterminate="kategori.penerimaan.isIndeterminate" v-model="kategori.penerimaan.checkAll" @change="handleKategoriCheckAllChange(kategori.penerimaan)" size="medium"><b>Penerimaan</b></el-checkbox>
                        <el-checkbox-group v-model="kategori.penerimaan.checked" @change="handleKategoriCheckedChange(kategori.penerimaan)">
                           <el-checkbox v-for="item in kategori.penerimaan.options" :label="item" :key="item">{{item}}</el-checkbox>
                        </el-checkbox-group>
                     </div>
                     <div>
                        <el-tabs v-model="tabPenerimaanActiveName" @tab-click="handleTabPenerimaanClick">
                           <el-tab-pane label="Penjualan" name="penerimaan_penjualan" v-if="isExistInArray(kategori.penerimaan.checked,'Penjualan')">
                              <div>
                                 <el-checkbox :indeterminate="label.penerimaan.penjualan.isIndeterminate" v-model="label.penerimaan.penjualan.checkAll" @change="handleKategoriCheckAllChange(label.penerimaan.penjualan)" size="medium"><b>Penjualan</b></el-checkbox>
                                 <el-checkbox-group v-model="label.penerimaan.penjualan.checked" @change="handleKategoriCheckedChange(label.penerimaan.penjualan)">
                                    <el-checkbox v-for="(item, index) in label.penerimaan.penjualan.options" :label="item" :key="item.Nama+'_'+index">{{item.Nama}}</el-checkbox>
                                 </el-checkbox-group>
                              </div>
                           </el-tab-pane>
                           <el-tab-pane label="Bunga Deposito" name="penerimaan_bunga_deposito" v-if="isExistInArray(kategori.penerimaan.checked,'Bunga Deposito')">
                              <div>
                                 <el-checkbox :indeterminate="label.penerimaan.bunga_deposito.isIndeterminate" v-model="label.penerimaan.bunga_deposito.checkAll" @change="handleKategoriCheckAllChange(label.penerimaan.bunga_deposito)" size="medium"><b>Bunga Deposito</b></el-checkbox>
                                 <el-checkbox-group v-model="label.penerimaan.bunga_deposito.checked" @change="handleKategoriCheckedChange(label.penerimaan.bunga_deposito)">
                                    <el-checkbox v-for="(item, index) in label.penerimaan.bunga_deposito.options" :label="item" :key="item.Nama+'_'+index">{{item.Nama}}</el-checkbox>
                                 </el-checkbox-group>
                              </div>
                           </el-tab-pane>
                           <el-tab-pane label="Bunga Notpool" name="penerimaan_bunga_notpool" v-if="isExistInArray(kategori.penerimaan.checked,'Bunga Notpool')">
                              <div>
                                 <el-checkbox :indeterminate="label.penerimaan.bunga_notpool.isIndeterminate" v-model="label.penerimaan.bunga_notpool.checkAll" @change="handleKategoriCheckAllChange(label.penerimaan.bunga_notpool)" size="medium"><b>Bunga Notpool</b></el-checkbox>
                                 <el-checkbox-group v-model="label.penerimaan.bunga_notpool.checked" @change="handleKategoriCheckedChange(label.penerimaan.bunga_notpool)">
                                    <el-checkbox v-for="(item, index) in label.penerimaan.bunga_notpool.options" :label="item" :key="item.Nama+'_'+index">{{item.Nama}}</el-checkbox>
                                 </el-checkbox-group>
                              </div>
                           </el-tab-pane>
                           <el-tab-pane label="Bunga Giro" name="penerimaan_bunga_giro" v-if="isExistInArray(kategori.penerimaan.checked,'Bunga Giro')">
                              <div>
                                 <el-checkbox :indeterminate="label.penerimaan.bunga_giro.isIndeterminate" v-model="label.penerimaan.bunga_giro.checkAll" @change="handleKategoriCheckAllChange(label.penerimaan.bunga_giro)" size="medium"><b>Bunga Giro</b></el-checkbox>
                                 <el-checkbox-group v-model="label.penerimaan.bunga_giro.checked" @change="handleKategoriCheckedChange(label.penerimaan.bunga_giro)">
                                    <el-checkbox v-for="(item, index) in label.penerimaan.bunga_giro.options" :label="item" :key="item.Nama+'_'+index">{{item.Nama}}</el-checkbox>
                                 </el-checkbox-group>
                              </div>
                           </el-tab-pane>
                        </el-tabs>
                        
                     </div>
                  </el-collapse-item>
                  <el-collapse-item title="Persentase Penerimaan" name="2">
                     <template slot="title">
                        <h6 style="margin-top:5px;">Persentase Penerimaan</h6>
                     </template>
                     <div>
                        <el-checkbox :indeterminate="kategori.persentasePenerimaan.isIndeterminate" v-model="kategori.persentasePenerimaan.checkAll" @change="handleKategoriCheckAllChange(kategori.persentasePenerimaan)" size="medium"><b>Persentase Penerimaan</b></el-checkbox>
                        <el-checkbox-group v-model="kategori.persentasePenerimaan.checked" @change="handleKategoriCheckedChange(kategori.persentasePenerimaan)">
                           <el-checkbox v-for="item in kategori.persentasePenerimaan.options" :label="item" :key="item">{{item}}</el-checkbox>
                        </el-checkbox-group>
                     </div>
                     <div>
                        <el-tabs v-model="tabPersentasePenerimaanActiveName" @tab-click="handleTabPenerimaanClick">
                           <el-tab-pane label="Penjualan" name="persentase_penerimaan_penjualan" v-if="isExistInArray(kategori.persentasePenerimaan.checked,'Penjualan')">
                              <div>
                                 <el-checkbox :indeterminate="label.persentasePenerimaan.penjualan.isIndeterminate" v-model="label.persentasePenerimaan.penjualan.checkAll" @change="handleKategoriCheckAllChange(label.persentasePenerimaan.penjualan)" size="medium"><b>Penjualan</b></el-checkbox>
                                 <el-checkbox-group v-model="label.persentasePenerimaan.penjualan.checked" @change="handleKategoriCheckedChange(label.persentasePenerimaan.penjualan)">
                                    <el-checkbox v-for="(item, index) in label.persentasePenerimaan.penjualan.options" :label="item" :key="item.Nama+'_'+index">{{item.Nama}}</el-checkbox>
                                 </el-checkbox-group>
                              </div>
                           </el-tab-pane>
                           <el-tab-pane label="Cash" name="persentase_penerimaan_cash" v-if="isExistInArray(kategori.persentasePenerimaan.checked,'Cash')">
                              <div>
                                 <el-checkbox :indeterminate="label.persentasePenerimaan.cash.isIndeterminate" v-model="label.persentasePenerimaan.cash.checkAll" @change="handleKategoriCheckAllChange(label.persentasePenerimaan.cash)" size="medium"><b>Cash</b></el-checkbox>
                                 <el-checkbox-group v-model="label.persentasePenerimaan.cash.checked" @change="handleKategoriCheckedChange(label.persentasePenerimaan.cash)">
                                    <el-checkbox v-for="(item, index) in label.persentasePenerimaan.cash.options" :label="item" :key="item.Nama+'_'+index">{{item.Nama}}</el-checkbox>
                                 </el-checkbox-group>
                              </div>
                           </el-tab-pane>
                           <el-tab-pane label="Non Cash" name="persentase_penerimaan_non_cash" v-if="isExistInArray(kategori.persentasePenerimaan.checked,'Non Cash')">
                              <div>
                                 <el-checkbox :indeterminate="label.persentasePenerimaan.non_cash.isIndeterminate" v-model="label.persentasePenerimaan.non_cash.checkAll" @change="handleKategoriCheckAllChange(label.persentasePenerimaan.non_cash)" size="medium"><b>Non Cash</b></el-checkbox>
                                 <el-checkbox-group v-model="label.persentasePenerimaan.non_cash.checked" @change="handleKategoriCheckedChange(label.persentasePenerimaan.non_cash)">
                                    <el-checkbox v-for="(item, index) in label.persentasePenerimaan.non_cash.options" :label="item" :key="item.Nama+'_'+index">{{item.Nama}}</el-checkbox>
                                 </el-checkbox-group>
                              </div>
                           </el-tab-pane>
                           <el-tab-pane label="Cash Per Day" name="persentase_penerimaan_cash_per_day" v-if="isExistInArray(kategori.persentasePenerimaan.checked,'Cash Per Day')">
                              <div>
                                 <el-checkbox :indeterminate="label.persentasePenerimaan.cash_per_day.isIndeterminate" v-model="label.persentasePenerimaan.cash_per_day.checkAll" @change="handleKategoriCheckAllChange(label.persentasePenerimaan.cash_per_day)" size="medium"><b>Cash Per Day</b></el-checkbox>
                                 <el-checkbox-group v-model="label.persentasePenerimaan.cash_per_day.checked" @change="handleKategoriCheckedChange(label.persentasePenerimaan.cash_per_day)">
                                    <el-checkbox v-for="(item, index) in label.persentasePenerimaan.cash_per_day.options" :label="item" :key="item.Nama+'_'+index">{{item.Nama}}</el-checkbox>
                                 </el-checkbox-group>
                              </div>
                           </el-tab-pane>
                           <el-tab-pane label="Non Cash Per Day" name="persentase_penerimaan_non_cash_per_day" v-if="isExistInArray(kategori.persentasePenerimaan.checked,'Non Cash Per Day')">
                              <div>
                                 <el-checkbox :indeterminate="label.persentasePenerimaan.non_cash_per_day.isIndeterminate" v-model="label.persentasePenerimaan.non_cash_per_day.checkAll" @change="handleKategoriCheckAllChange(label.persentasePenerimaan.non_cash_per_day)" size="medium"><b>Non Cash Per Day</b></el-checkbox>
                                 <el-checkbox-group v-model="label.persentasePenerimaan.non_cash_per_day.checked" @change="handleKategoriCheckedChange(label.persentasePenerimaan.non_cash_per_day)">
                                    <el-checkbox v-for="(item, index) in label.persentasePenerimaan.non_cash_per_day.options" :label="item" :key="item.Nama+'_'+index">{{item.Nama}}</el-checkbox>
                                 </el-checkbox-group>
                              </div>
                           </el-tab-pane>
                           <el-tab-pane label="Rata Rata Per Day" name="persentase_penerimaan_rata_rata_per_day" v-if="isExistInArray(kategori.persentasePenerimaan.checked,'Rata Rata Per Day')">
                              <div>
                                 <el-checkbox :indeterminate="label.persentasePenerimaan.rata_rata_day.isIndeterminate" v-model="label.persentasePenerimaan.rata_rata_day.checkAll" @change="handleKategoriCheckAllChange(label.persentasePenerimaan.rata_rata_day)" size="medium"><b>Rata Rata Per Day</b></el-checkbox>
                                 <el-checkbox-group v-model="label.persentasePenerimaan.rata_rata_day.checked" @change="handleKategoriCheckedChange(label.persentasePenerimaan.rata_rata_day)">
                                    <el-checkbox v-for="(item, index) in label.persentasePenerimaan.rata_rata_day.options" :label="item" :key="item.Nama+'_'+index">{{item.Nama}}</el-checkbox>
                                 </el-checkbox-group>
                              </div>
                           </el-tab-pane>
                        </el-tabs>
                     </div>
                  </el-collapse-item>
                  <el-collapse-item title="Pengeluaran" name="3">
                     <template slot="title">
                        <h6 style="margin-top:5px;">Pengeluaran</h6>
                     </template>
                     <div>
                        <el-checkbox :indeterminate="kategori.pengeluaran.isIndeterminate" v-model="kategori.pengeluaran.checkAll" @change="handleKategoriCheckAllChange(kategori.pengeluaran)" size="medium"><b>Pengeluaran</b></el-checkbox>
                        <el-checkbox-group v-model="kategori.pengeluaran.checked" @change="handleKategoriCheckedChange(kategori.pengeluaran)">
                           <el-checkbox v-for="item in kategori.pengeluaran.options" :label="item" :key="item">{{item}}</el-checkbox>
                        </el-checkbox-group>
                     </div>
                     <div>
                        <el-tabs v-model="tabPengeluaranActiveName" @tab-click="handleTabPenerimaanClick">
                           <el-tab-pane label="Pengeluaran" name="pengeluaran_pengeluaran" v-if="isExistInArray(kategori.pengeluaran.checked,'Pengeluaran')">
                              <div>
                                 <el-checkbox :indeterminate="label.pengeluaran.pengeluaran.isIndeterminate" v-model="label.pengeluaran.pengeluaran.checkAll" @change="handleKategoriCheckAllChange(label.pengeluaran.pengeluaran)" size="medium"><b>Pengeluaran</b></el-checkbox>
                                 <el-checkbox-group v-model="label.pengeluaran.pengeluaran.checked" @change="handleKategoriCheckedChange(label.pengeluaran.pengeluaran)">
                                    <el-checkbox v-for="(item, index) in label.pengeluaran.pengeluaran.options" :label="item" :key="item.Nama+'_'+index">{{item.Nama}}</el-checkbox>
                                 </el-checkbox-group>
                              </div>
                           </el-tab-pane>
                           <el-tab-pane label="Biaya Administrasi Bank" name="pengeluaran_biaya_administrasi_bank" v-if="isExistInArray(kategori.pengeluaran.checked,'Biaya Administrasi Bank')">
                              <div>
                                 <el-checkbox :indeterminate="label.pengeluaran.biaya_administrasi_bank.isIndeterminate" v-model="label.pengeluaran.biaya_administrasi_bank.checkAll" @change="handleKategoriCheckAllChange(label.pengeluaran.biaya_administrasi_bank)" size="medium"><b>Biaya Administrasi Bank</b></el-checkbox>
                                 <el-checkbox-group v-model="label.pengeluaran.biaya_administrasi_bank.checked" @change="handleKategoriCheckedChange(label.pengeluaran.biaya_administrasi_bank)">
                                    <el-checkbox v-for="(item, index) in label.pengeluaran.biaya_administrasi_bank.options" :label="item" :key="item.Nama+'_'+index">{{item.Nama}}</el-checkbox>
                                 </el-checkbox-group>
                              </div>
                           </el-tab-pane>
                           <el-tab-pane label="Bank Charge" name="pengeluaran_bank_charge" v-if="isExistInArray(kategori.pengeluaran.checked,'Bank Charge')">
                              <div>
                                 <el-checkbox :indeterminate="label.pengeluaran.bank_charge.isIndeterminate" v-model="label.pengeluaran.bank_charge.checkAll" @change="handleKategoriCheckAllChange(label.pengeluaran.bank_charge)" size="medium"><b>Bank Charge</b></el-checkbox>
                                 <el-checkbox-group v-model="label.pengeluaran.bank_charge.checked" @change="handleKategoriCheckedChange(label.pengeluaran.bank_charge)">
                                    <el-checkbox v-for="(item, index) in label.pengeluaran.bank_charge.options" :label="item" :key="item.Nama+'_'+index">{{item.Nama}}</el-checkbox>
                                 </el-checkbox-group>
                              </div>
                           </el-tab-pane>
                           <el-tab-pane label="Pajak Giro" name="pengeluaran_pajak_giro" v-if="isExistInArray(kategori.pengeluaran.checked,'Pajak Giro')">
                              <div>
                                 <el-checkbox :indeterminate="label.pengeluaran.pajak_giro.isIndeterminate" v-model="label.pengeluaran.pajak_giro.checkAll" @change="handleKategoriCheckAllChange(label.pengeluaran.pajak_giro)" size="medium"><b>Pajak Giro</b></el-checkbox>
                                 <el-checkbox-group v-model="label.pengeluaran.pajak_giro.checked" @change="handleKategoriCheckedChange(label.pengeluaran.pajak_giro)">
                                    <el-checkbox v-for="(item, index) in label.pengeluaran.pajak_giro.options" :label="item" :key="item.Nama+'_'+index">{{item.Nama}}</el-checkbox>
                                 </el-checkbox-group>
                              </div>
                           </el-tab-pane>
                           <el-tab-pane label="Pajak Notpool" name="pengeluaran_pajak_notpool" v-if="isExistInArray(kategori.pengeluaran.checked,'Pajak Notpool')">
                              <div>
                                 <el-checkbox :indeterminate="label.pengeluaran.pajak_notpool.isIndeterminate" v-model="label.pengeluaran.pajak_notpool.checkAll" @change="handleKategoriCheckAllChange(label.pengeluaran.pajak_notpool)" size="medium"><b>Pajak Notpool</b></el-checkbox>
                                 <el-checkbox-group v-model="label.pengeluaran.pajak_notpool.checked" @change="handleKategoriCheckedChange(label.pengeluaran.pajak_notpool)">
                                    <el-checkbox v-for="(item, index) in label.pengeluaran.pajak_notpool.options" :label="item" :key="item.Nama+'_'+index">{{item.Nama}}</el-checkbox>
                                 </el-checkbox-group>
                              </div>
                           </el-tab-pane>
                        </el-tabs>
                     </div>
                  </el-collapse-item>
                  <el-collapse-item title="Persentase Pengeluaran" name="4">
                     <template slot="title">
                        <h6 style="margin-top:5px;">Persentase Pengeluaran</h6>
                     </template>
                     <div>
                        <el-checkbox :indeterminate="kategori.persentasePengeluaran.isIndeterminate" v-model="kategori.persentasePengeluaran.checkAll" @change="handleKategoriCheckAllChange(kategori.persentasePengeluaran)" size="medium"><b>Persentase Pengeluaran</b></el-checkbox>
                        <el-checkbox-group v-model="kategori.persentasePengeluaran.checked" @change="handleKategoriCheckedChange(kategori.persentasePengeluaran)">
                           <el-checkbox v-for="item in kategori.persentasePengeluaran.options" :label="item" :key="item">{{item}}</el-checkbox>
                        </el-checkbox-group>
                     </div>
                     <div>
                        <el-tabs v-model="tabPersentasePengeluaranActiveName" @tab-click="handleTabPenerimaanClick">
                           <el-tab-pane label="Pengeluaran" name="persentase_pengeluaran_pengeluaran" v-if="isExistInArray(kategori.persentasePengeluaran.checked,'Pengeluaran')">
                              <div>
                                 <el-checkbox :indeterminate="label.persentasePengeluaran.pengeluaran.isIndeterminate" v-model="label.persentasePengeluaran.pengeluaran.checkAll" @change="handleKategoriCheckAllChange(label.persentasePengeluaran.pengeluaran)" size="medium"><b>Pengeluaran</b></el-checkbox>
                                 <el-checkbox-group v-model="label.persentasePengeluaran.pengeluaran.checked" @change="handleKategoriCheckedChange(label.persentasePengeluaran.pengeluaran)">
                                    <el-checkbox v-for="(item, index) in label.persentasePengeluaran.pengeluaran.options" :label="item" :key="item.Nama+'_'+index">{{item.Nama}}</el-checkbox>
                                 </el-checkbox-group>
                              </div>
                           </el-tab-pane>
                           <el-tab-pane label="Pengeluaran Per Bank" name="persentase_pengeluaran_pengeluaran_bank" v-if="isExistInArray(kategori.persentasePengeluaran.checked,'Pengeluaran Per Bank')">
                              <div>
                                 <el-checkbox :indeterminate="label.persentasePengeluaran.pengeluaran_per_bank.isIndeterminate" v-model="label.persentasePengeluaran.pengeluaran_per_bank.checkAll" @change="handleKategoriCheckAllChange(label.persentasePengeluaran.pengeluaran_per_bank)" size="medium"><b>Pengeluaran Per Bank</b></el-checkbox>
                                 <el-checkbox-group v-model="label.persentasePengeluaran.pengeluaran_per_bank.checked" @change="handleKategoriCheckedChange(label.persentasePengeluaran.pengeluaran_per_bank)">
                                    <el-checkbox v-for="(item, index) in label.persentasePengeluaran.pengeluaran_per_bank.options" :label="item" :key="item.Nama+'_'+index">{{item.Nama}}</el-checkbox>
                                 </el-checkbox-group>
                              </div>
                           </el-tab-pane>
                           <el-tab-pane label="Biaya Administrasi Bank" name="persentase_pengeluaran_biaya_administrasi_bank" v-if="isExistInArray(kategori.persentasePengeluaran.checked,'Biaya Administrasi Bank')">
                              <div>
                                 <el-checkbox :indeterminate="label.persentasePengeluaran.biaya_administrasi_bank.isIndeterminate" v-model="label.persentasePengeluaran.biaya_administrasi_bank.checkAll" @change="handleKategoriCheckAllChange(label.persentasePengeluaran.biaya_administrasi_bank)" size="medium"><b>Biaya Administrasi Bank</b></el-checkbox>
                                 <el-checkbox-group v-model="label.persentasePengeluaran.biaya_administrasi_bank.checked" @change="handleKategoriCheckedChange(label.persentasePengeluaran.biaya_administrasi_bank)">
                                    <el-checkbox v-for="(item, index) in label.persentasePengeluaran.biaya_administrasi_bank.options" :label="item" :key="item.Nama+'_'+index">{{item.Nama}}</el-checkbox>
                                 </el-checkbox-group>
                              </div>
                           </el-tab-pane>
                           
                           <el-tab-pane label="Pajak Giro" name="persentase_pengeluaran_pajak_giro" v-if="isExistInArray(kategori.persentasePengeluaran.checked,'Pajak Giro')">
                              <div>
                                 <el-checkbox :indeterminate="label.persentasePengeluaran.pajak_giro.isIndeterminate" v-model="label.persentasePengeluaran.pajak_giro.checkAll" @change="handleKategoriCheckAllChange(label.persentasePengeluaran.pajak_giro)" size="medium"><b>Pajak Giro</b></el-checkbox>
                                 <el-checkbox-group v-model="label.persentasePengeluaran.pajak_giro.checked" @change="handleKategoriCheckedChange(label.persentasePengeluaran.pajak_giro)">
                                    <el-checkbox v-for="(item, index) in label.persentasePengeluaran.pajak_giro.options" :label="item" :key="item.Nama+'_'+index">{{item.Nama}}</el-checkbox>
                                 </el-checkbox-group>
                              </div>
                           </el-tab-pane>
                           <el-tab-pane label="Bank Charge" name="persentase_pengeluaran_bank_charge" v-if="isExistInArray(kategori.persentasePengeluaran.checked,'Bank Charge')">
                              <div>
                                 <el-checkbox :indeterminate="label.persentasePengeluaran.bank_charge.isIndeterminate" v-model="label.persentasePengeluaran.bank_charge.checkAll" @change="handleKategoriCheckAllChange(label.persentasePengeluaran.bank_charge)" size="medium"><b>Bank Charge</b></el-checkbox>
                                 <el-checkbox-group v-model="label.persentasePengeluaran.bank_charge.checked" @change="handleKategoriCheckedChange(label.persentasePengeluaran.bank_charge)">
                                    <el-checkbox v-for="(item, index) in label.persentasePengeluaran.bank_charge.options" :label="item" :key="item.Nama+'_'+index">{{item.Nama}}</el-checkbox>
                                 </el-checkbox-group>
                              </div>
                           </el-tab-pane>
                                        
                        </el-tabs>
                     </div>
                  </el-collapse-item>
               </el-collapse>
               
            </div>
            
            <div class="col-md-12 mt-2">
               <el-checkbox v-model="filter.comparisonChartVisibility"  size="medium"><b>Tampilkan Perbandingan</b></el-checkbox>
            </div>

            <div class="col-md-12 mb-4">
               <el-checkbox v-model="filter.tabChartPenerimaanVisbility"  size="medium"><b>Tab Version</b></el-checkbox>
            </div>
          
            <div class="col-md-12 mb-0" style="position:sticky;bottom:0;z-index:30;background:white;">
               <hr style="padding:0;margin:0;">
               <div class="row" style="padding-bottom:1rem;padding-top:1rem;">
                  <div class="col-md-6">
                     <el-button type="warning" style="width:100%;" v-on:click="handleCloseFilterDrawer">Cancel</el-button>
                  </div>
                  <div class="col-md-6">
                     <el-button type="primary" style="width:100%;" v-on:click="handleApplyFilter">Apply</el-button>
                  </div>
               </div>
            </div>
         </div>
      
      </el-drawer>
   </div>
</template>

<script>
import Treasury from '@/components/page/Treasury.js'
import { Rainbow, Rainbow3, Config, AxiosWithJar } from '@/utility.js'
import $ from 'jquery'

export default {
   extends: Treasury,
   //props: ["filterDrawer"],
   props:{
      filterDrawerVisibility: {
         //type: Boolean, //optional data type
         default: false,
      },

   },
	components:{
		//ListItem,
		//ListCompare,          
	},
   mounted(){
		this.loadMonths();
		this.loadSummaryLabel();
   },
   data() {
		return {
			isModalVisible: false,
			months:[],
			//filterDrawerVisibility: false,
			filterDrawerDirection: 'rtl',
			monthList:[],
			activeNames: ['1'],
			form: {
            name: '',
            region: '',
            date1: '',
            date2: '',
            delivery: false,
            type: [],
            resource: '',
            desc: ''
			},

			//new filter
         filter: {
            dataType: 'total',
            comparisonChartVisibility: false,
            tabChartPenerimaanVisbility: false, //sample
         },
			tabPenerimaanActiveName: 'penerimaan_penjualan',
			tabPersentasePenerimaanActiveName: 'persentase_penerimaan_penjualan',
			tabPengeluaranActiveName: 'pengeluaran_pengeluaran',
			tabPersentasePengeluaranActiveName: 'persentase_pengeluaran_pengeluaran',
			kategori: {
				penerimaan: {
					options: ['Penjualan', 'Bunga Deposito', 'Bunga Notpool', 'Bunga Giro'],
					checked: ['Penjualan'],
					checkAll: false,
					isIndeterminate: true,
				},
				persentasePenerimaan: {
					options: ['Penjualan', 'Cash', 'Non Cash', 'Cash Per Day', 'Non Cash Per Day', 'Rata Rata Per Day'],
					checked: ['Penjualan'],
					checkAll: false,
					isIndeterminate: true,
				},
				pengeluaran: {
					options: ['Pengeluaran', 'Biaya Administrasi Bank', 'Pajak Notpool', 'Pajak Giro', 'Bank Charge'],
					checked: ['Pengeluaran'],
					checkAll: false,
					isIndeterminate: true,
				},
				persentasePengeluaran: {
					options: ['Pengeluaran', 'Pengeluaran Per Bank', 'Biaya Administrasi Bank', 'Pajak Giro', 'Bank Charge'],
					checked: ['Pengeluaran'],
					checkAll: false,
					isIndeterminate: true,
				},
			},

			label: {
				penerimaan: {
					penjualan: {
						options: [],
						checked: [],
						checkAll: false,
						isIndeterminate: true,
					},
					bunga_deposito: {
						options: [],
						checked: [],
						checkAll: false,
						isIndeterminate: true,
					},
					bunga_giro: {
						options: [],
						checked: [],
						checkAll: false,
						isIndeterminate: true,
					},
					bunga_notpool: {
						options: [],
						checked: [],
						checkAll: false,
						isIndeterminate: true,
					},
				},
				persentasePenerimaan: {
					cash: {
						options: [],
						checked: [],
						checkAll: false,
						isIndeterminate: true,
					},
					non_cash: {
						options: [],
						checked: [],
						checkAll: false,
						isIndeterminate: true,
					},
					cash_per_day: {
						options: [],
						checked: [],
						checkAll: false,
						isIndeterminate: true,
					},
					non_cash_per_day: {
						options: [],
						checked: [],
						checkAll: false,
						isIndeterminate: true,
					},
					penjualan: {
						options: [],
						checked: [],
						checkAll: false,
						isIndeterminate: true,
					},
					rata_rata_day: {
						options: [],
						checked: [],
						checkAll: false,
						isIndeterminate: true,
					},
				},
				pengeluaran: {
					bank_charge: {
						options: [],
						checked: [],
						checkAll: false,
						isIndeterminate: true,
					},
					biaya_administrasi_bank: {
						options: [],
						checked: [],
						checkAll: false,
						isIndeterminate: true,
					},
					pajak_giro: {
						options: [],
						checked: [],
						checkAll: false,
						isIndeterminate: true,
					},
					pajak_notpool: {
						options: [],
						checked: [],
						checkAll: false,
						isIndeterminate: true,
					},
					pengeluaran: {
						options: [],
						checked: [],
						checkAll: false,
						isIndeterminate: true,
					},
				},
				persentasePengeluaran: {
					pengeluaran: {
						options: [],
						checked: [],
						checkAll: false,
						isIndeterminate: true,
					},
					bank_charge: {
						options: [],
						checked: [],
						checkAll: false,
						isIndeterminate: true,
					},
					biaya_administrasi_bank: {
						options: [],
						checked: [],
						checkAll: false,
						isIndeterminate: true,
					},
					pengeluaran_per_bank: {
						options: [],
						checked: [],
						checkAll: false,
						isIndeterminate: true,
					},
					pajak_giro: {
						options: [],
						checked: [],
						checkAll: false,
						isIndeterminate: true,
					},
				},
			},

			month: {
				list: ["January", "February", "March", "April", "May", "June","July", "August", "September", "October", "November", "December"],
            options: [],
				checked: [],
				checkAll: false,
				isIndeterminate: true,
			},

			year: {
				options: [],
				checked: [],
				checkAll: false,
				isIndeterminate: true,
			},

			//cascader
			props: { multiple: true, checkStrictly: false },
			options: [
				{
					value: 1,
					label: 'Penerimaan',
					children: [
						{
							value: 2,
							label: 'Penjualan',
							children: [],
						}, 
						{
							value: 6,
							label: 'Bunga Deposito',
							checkStrictly: true,
							children: [
								{ value: 7, label: 'BCA - PT. Bank Central Asia Tbk',  },
								{ value: 8, label: 'BNI' },
								{ value: 9, label: 'BRI' }
							]
						}, 
						{
							value: 10,
							label: 'Bunga Giro',
							children: [
								{ value: 11, label: 'BCA PEMBIAYAAN' },
								{ value: 12, label: 'BCA PENAMPUNGAN' },
								{ value: 13, label: 'BCA UTAMA' }
							]
						},
						{
							value: 10,
							label: 'Bunga Notpool',
							children: [
								{ value: 11, label: 'BRI' },
								{ value: 12, label: 'MANDIRI' },
								{ value: 13, label: 'BNI' }
							]
						},
					]
				},
				{
					value: 14,
					label: 'Persentase Penerimaan',
					children: [
						{
							value: 15,
							label: 'Cash',
							children: [
								{ value: 16, label: 'BCA' },
								{ value: 17, label: 'BRI' },
								{ value: 18, label: 'BNI' }
							]
						},
						{
							value: 19,
							label: 'Non Cash',
							children: [
								{ value: 20, label: 'BCA' },
								{ value: 21, label: 'BNI' },
								{ value: 22, label: 'BRI' }
							]
						}
					]
				},
				{
					value: 23,
					label: 'Pengeluaran',
					children: [
						{
							value: 24,
							label: 'Pengeluaran',
							children: [
							{ value: 25, label: 'Advance e toll' },
							{ value: 26, label: 'BIAYA PICK UP' },
							{ value: 27, label: 'BPJS' }
							]
						},
						{
							value: 28,
							label: 'Biaya Administrasi',
							children: [
								{ value: 29, label: 'BCA BRIGHT' },
								{ value: 30, label: 'BCA EDC' },
								{ value: 31, label: 'BCA EDC BRIGHT' }
							]
						}
					]
				},
				{
					value: 23,
					label: 'Persentase Pengeluaran',
					children: [
						{
							value: 24,
							label: 'Pengeluaran',
							children: [
								{ value: 25, label: 'BIAYA PICK UP' },
								{ value: 26, label: 'SPD / Advance' },
								{ value: 27, label: 'Internal' }
							]
						},
						{
							value: 28,
							label: 'Pengeluaran Per Bank',
							children: [
								{ value: 29, label: 'BSI' },
								{ value: 30, label: 'BTN' },
								{ value: 31, label: 'BRI' }
							]
						}
					]
				},
			],
		}
	},
   methods:{
      test() {
         this.filterDrawerVisibility = false
      },
		//new filter
		handleKategoriCheckAllChange(data) {
			let val = data.checkAll;
			//console.log('val: ' + val); //true or false
			data.checked = val ? data.options : [];
			data.isIndeterminate = false;

			//manual
			//this.kategori.penerimaan.checked = val ? this.kategori.penerimaan.options : [];
			//this.kategori.penerimaan.isIndeterminate = false;
      },

      handleKategoriCheckedChange(data) {
			let value = data.checked;
			//console.log('value: ' + JSON.stringify(value));
			let checkedCount = value.length;
			data.checkAll = checkedCount === data.options.length;
			data.isIndeterminate = checkedCount > 0 && checkedCount < data.options.length;

			//manual
			//this.kategori.penerimaan.checkAll = checkedCount === this.kategori.penerimaan.options.length;
			//this.kategori.penerimaan.isIndeterminate = checkedCount > 0 && checkedCount < this.kategori.penerimaan.options.length;
      },
		
		isExistInArray(array, searchElement, fromIndex) {
			//console.log('array: '+array)
			let result = array.map(function(value) { 
				return value.toLowerCase();
			}).indexOf(searchElement.toLowerCase(), fromIndex);

			if (result !== -1)
				return true;

			return false;
		},

		loadMonths() {
			for (let i = 0; i <= 11; i++) {
				//console.log("month: " +i);
				let month = { Id: i+1, Name: this.month.list[i], Grup: 1}
				this.month.options.push(month);
				this.month.checked.push(month);
			} 
		},

		async loadSummaryLabel() {         
			let url = Config().apiURL + "/finance/treasury-label?";
			await AxiosWithJar().get(url).then(result => {
				this.year.options = result.data.years;

				this.label.penerimaan.penjualan.options = result.data.penerimaan.penjualan;
				this.label.penerimaan.bunga_deposito.options = result.data.penerimaan.bunga_deposito;
				this.label.penerimaan.bunga_giro.options = result.data.penerimaan.bunga_giro;
				this.label.penerimaan.bunga_notpool.options = result.data.penerimaan.bunga_notpool;

				this.label.pengeluaran.bank_charge.options = result.data.pengeluaran.bank_charge;
				this.label.pengeluaran.biaya_administrasi_bank.options = result.data.pengeluaran.biaya_administrasi_bank;
				this.label.pengeluaran.pajak_giro.options = result.data.pengeluaran.pajak_giro;
				this.label.pengeluaran.pajak_notpool.options = result.data.pengeluaran.pajak_notpool;
				this.label.pengeluaran.pengeluaran.options = result.data.pengeluaran.pengeluaran;

				this.label.persentasePenerimaan.cash.options = result.data.penerimaan_persentase.cash;
				this.label.persentasePenerimaan.cash_per_day.options = result.data.penerimaan_persentase.cash_per_day;
				this.label.persentasePenerimaan.non_cash.options = result.data.penerimaan_persentase.non_cash;
				this.label.persentasePenerimaan.non_cash_per_day.options = result.data.penerimaan_persentase.non_cash_per_day;
				this.label.persentasePenerimaan.penjualan.options = result.data.penerimaan_persentase.penjualan;
				this.label.persentasePenerimaan.rata_rata_day.options = result.data.penerimaan_persentase.rata_rata_day;

				this.label.persentasePengeluaran.pengeluaran.options = result.data.pengeluaran_persentase.pengeluaran;
				this.label.persentasePengeluaran.bank_charge.options = result.data.pengeluaran_persentase.bank_charge;
				this.label.persentasePengeluaran.biaya_administrasi_bank.options = result.data.pengeluaran_persentase.biaya_administrasi_bank;
				this.label.persentasePengeluaran.pengeluaran_per_bank.options = result.data.pengeluaran_persentase.pengeluaran_per_bank;
				this.label.persentasePengeluaran.pajak_giro.options = result.data.pengeluaran_persentase.pajak_giro;
				
				this.options[0].children[0].children = this.label.penerimaan.penjualan.options;
			})
		}, 
		
		handleCascaderChange(value){
			console.log('value cascader: ' + value)
			const result = this.$refs.cascader.getCheckedNodes();
			console.log(result)
      },
		//end new filter

      filterModal() {
         this.isModalVisible = true;			
         this.$nextTick(() => {
               $('#modal').modal('show');
         });
      },

      closeModal() {			
         this.isModalVisible = false;
         this.$nextTick(() => {
               $('#modal').modal('hide');
         }); 
      },

		handleCloseFilterDrawer(done) {
			//this.filterDrawerVisibility = false;
         this.$emit('close-filter-drawer');
			/*
        this.$confirm('Are you sure you want to close this?')
          .then(_ => {
            done();
          })
          .catch(_ => {}); */
      },

      handleApplyFilter() {
         this.$emit('apply-filter-change', { 
               kategori: this.kategori, 
               label: this.label,
               month: this.month,
               year: this.year,
               filter: this.filter,
            }
         );
      },

      handleTabPenerimaanClick(tab, event) {
        console.log(tab, event);
      },

		handleChangeCollapse(val) {
        console.log(val);
      },

		handleChangeStartMonth() {
			this.getMonths('3-1-2021','8-1-2022');
			console.log('aaa');
		},

		getMonths(startDate, endDate1) {
			var resultList = [];
			var date = new Date(startDate);
			var endDate = new Date(endDate1);
			var monthNameList = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

			while (date <= endDate)
			{
				var stringDate = monthNameList[date.getMonth()] + " " + date.getFullYear();
				
				//get first and last day of month
				var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
				var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
				
				resultList.push({
						str:stringDate,
						first:firstDay,
						last:lastDay,
				});
				date.setMonth(date.getMonth() + 1);
			}
			
			this.monthList = resultList;
			return resultList;
		}

	},
}
</script>